import React from 'react';
import {
  Burger, Header as MHeader,
  useMantineTheme, Group, Box, Flex, Anchor,
} from '@mantine/core';
import { Link } from 'react-router-dom';
import { useWindowScroll } from '@mantine/hooks';

import { ProfileMenu } from './profile-menu';
import { grp } from '../routes';
import { HEADER_HEIGHT, PROJECT_NAME } from '../constants';

import Logo from '../assets/images/logo.svg';
import LogoWhite from '../assets/images/logo-white.svg';

export const Header: React.FC<{
  navbarOpened: boolean
  setNavbarOpened: (value: React.SetStateAction<boolean>) => void
}> = ({ navbarOpened, setNavbarOpened }) => {
  const theme = useMantineTheme();
  const [scroll] = useWindowScroll();

  return (
    <MHeader
      height={HEADER_HEIGHT}
      px="md"
      bg={{
        base: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.white,
        md: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.other.lightBodyBackgroundColor,
      }}
      sx={{
        [theme.fn.largerThan('md')]: {
          borderBottomColor: 'transparent',
          boxShadow: scroll.y > 40 ? theme.shadows.sm : 'none',
        },
      }}
    >
      <Flex align="center" h="100%">
        <Burger
          opened={navbarOpened}
          onClick={() => setNavbarOpened((o) => !o)}
          size="sm"
          color={theme.colors.gray[6]}
          mr="sm"
          display={{ base: 'block', md: 'none' }}
        />

        <Group w="100%">
          <Box
            h={23}
            display={{ base: 'inline-block', md: 'none' }}
          >
            <Anchor component={Link} to={grp('homepage')}>
              {theme.colorScheme === 'dark'
                ? <img src={LogoWhite} height={23} alt={PROJECT_NAME} />
                : <img src={Logo} height={23} alt={PROJECT_NAME} />}
            </Anchor>
          </Box>

          <Group ml="auto">
            <ProfileMenu />
          </Group>
        </Group>
      </Flex>
    </MHeader>
  );
};
